const MONTH_INDEX = 1;  // Month Index starts with 0

let countDownDate = new Date(2022, MONTH_INDEX, 3);
const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

const countDown = document.querySelector('.count-down');
const daysEl = document.getElementById('days');
const hoursEl = document.getElementById('hours');
const minutesEl = document.getElementById('minutes');
const secondsEl = document.getElementById('seconds');

function updateCountDown() {
  let isDateValid = isCountDownDateGreaterThanNow(countDownDate);
  if (!isDateValid) incrementDays(1);
  isDateValid = isCountDownDateGreaterThanNow(countDownDate);

  const diff = countDownDate - new Date();
  const days = Math.floor(diff / DAY);
  const hours = Math.floor(diff / HOUR);
  const minutes = Math.floor(diff / MINUTE);
  const seconds = Math.floor(diff / SECOND);


  const countDownInDays = isDateValid ? days : 0;
  const countDownInHours = isDateValid ? hours - days * 24 : 0;
  const countDownInMinutes = isDateValid ? minutes - hours * 60 : 0;
  const countDownInSeconds = isDateValid ? seconds - minutes * 60 : 0;

  setDays(countDownInDays);
  setHours(countDownInHours);
  setMinutes(countDownInMinutes);
  setSeconds(countDownInSeconds);
}

function setDays(days) {
  daysEl.innerHTML = `
    <span>${days < 10 ? '0' : ''}${days}</span>
    <span class='text'>Day${days <= 1 ? '' : 's'}</span>
  `;
}

function setHours(hours) {
  hoursEl.innerHTML = `
    <span>${hours < 10 ? '0' : ''}${hours}</span>
    <span class='text'>Hour${hours <= 1 ? '' : 's'}</span>
  `;
}

function setMinutes(minutes) {
  minutesEl.innerHTML = `
    <span>${minutes < 10 ? '0' : ''}${minutes}</span>
    <span class='text'>Minute${minutes <= 1 ? '' : 's'}</span>
  `;
}

function setSeconds(seconds) {
  secondsEl.innerHTML = `
    <span>${seconds < 10 ? '0' : ''}${seconds}</span>
    <span class='text'>Second${seconds <= 1 ? '' : 's'}</span>
  `;
}

function isCountDownDateGreaterThanNow(date) {
  return date > new Date();
}

function incrementDays(noOfDays) {
  const date = new Date();
  date.setHours(0);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setDate(date.getDate() + noOfDays);
  countDownDate = date;
}

setInterval(updateCountDown, 1000);
setTimeout(() => {
  countDown.classList.add('show');
}, 1000);